import { useNavigate } from 'react-router-dom';

const PaiementErreurPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
        <span className="text-3xl text-red-600">✕</span>
      </div>
      <h1 className="text-2xl font-semibold text-slate-800">Paiement non confirmé</h1>
      <p className="text-slate-600">Le paiement n'a pas pu être vérifié. Réessayez ou contactez-nous.</p>
      <button onClick={() => navigate('/elearning')} className="mt-2 px-6 py-2 bg-slate-800 text-white rounded-lg">
        Retour aux formations
      </button>
    </div>
  );
};

export default PaiementErreurPage;